import PackageTender from '@/models/PackageTender';
import PackageTenderService from '@/services/PackageTenderService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePackageTendersStore = defineStore('packageTenders', {
  state: () => ({}),

  getters: {
    models: () => useRepo(PackageTender),
  },

  actions: {
    async index(projectId: Id, packageId: Id) {
      const [data, error] = await PackageTenderService.index(projectId, packageId);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async issue(projectId: Id, packageId: Id, form: ApiRequests['api.v1.packages.tenders.issue']) {
      const [data, error] = await PackageTenderService.issue(projectId, packageId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async selectWinner(projectId: Id, packageId: Id, form: ApiRequests['api.v1.packages.tenders.select-winner']) {
      const [data, error] = await PackageTenderService.selectWinner(projectId, packageId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async submit(tenderId: Id, signedParams: unknown) {
      const [data, error] = await PackageTenderService.submit(tenderId, signedParams);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async export(projectId: Id, packageId: Id) {
      const [data, error] = await PackageTenderService.export(projectId, packageId);

      if(error) {
        throw error;
      }

      return data;
    },
  },
});
